import React from 'react'
import { motion } from "framer-motion"
import styles from './Services.module.scss'
import icon_1 from '../../image/Practical/img_1.jpg'
import icon_2 from '../../image/Practical/img_2.jpg'
import icon_3 from '../../image/Practical/img_3.jpg'
import icon_4 from '../../image/Practical/img_4.webp'
import icon_5 from '../../image/Practical/img_5.jpg'
import icon_6 from '../../image/Practical/img_6.jpg'

const titleAnimation = {
    hidden: {
        y: 200,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5}
    } 
}

export const Services = ({isOpen}) => {

    return (
        <motion.section 
            className={styles.main} 
            id='Services'
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.05, once: true}}
            >
                <div className={styles.box}>
                    <motion.h2 className={styles.title} variants={titleAnimation}>Что мы предлагаем</motion.h2>
                    <motion.ul className={styles.list} >
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                            <h3 className={styles.item_title}>Продажа асфальта</h3>
                            <img className={styles.item_image}  src={icon_1} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                            <h3 className={styles.item_title}>асфальтирование дорог</h3>
                            <img className={styles.item_image}  src={icon_2} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                            <h3 className={styles.item_title}>асфальтовая крошка</h3>
                            <img className={styles.item_image}  src={icon_3} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                            <h3 className={styles.item_title}>ЯМОЧНЫЙ РЕМОНТ</h3>
                            <img className={styles.item_image}  src={icon_4} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                        >
                            <h3 className={styles.item_title}>Благоустройство</h3>
                            <img className={styles.item_image}  src={icon_5} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                            <h3 className={styles.item_title}>Аренда техники</h3>
                            <img className={styles.item_image}  src={icon_6} alt='дом'/>
                            <a className={styles.button} href="tel:+79785208861" target='_blank' rel='noopener noreferrer'>ЗАКАЗАТЬ <span className={styles.glare}></span></a>
                        </motion.li>
                    </motion.ul>
                </div>
        </motion.section>
        
    )
}